<header class="modal__header">
  <h2 class="modal__title" matDialogTitle>
    <ng-container *ngIf="title">{{title | translate}}</ng-container>
  </h2>
  <button mat-icon-button color="primary" class="modal__close" title="{{'APP.GENERAL.CLOSE' | translate}}"  (click)="no()" mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</header>

<section class="modal__content">
  <ng-container *ngIf="message">
    <p *ngIf="!translateParams">{{message | translate}}</p>
    <p *ngIf="translateParams">{{message | translate:translateParams}}</p>
  </ng-container>
</section>

<div class="modal__footer">
  <button type="button" class="button button--warn" mat-dialog-close (click)="no()">
    <span>{{ 'APP.GENERAL.NO' | translate }}</span>
  </button>
  <button type="button" class="button button--primary" (click)="yes()">
    <span>{{ 'APP.GENERAL.YES' | translate }}</span>
  </button>
</div>
